var _circle, _path, _path2, _g, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPotentialinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#E4E9F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 34c0 18.778-15.222 34-34 34S0 52.778 0 34 15.222 0 34 0s34 15.222 34 34z",
    fill: "#E4E9F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.468 9.459C16.577 3.6 24.868 0 34 0c18.778 0 34 15.222 34 34 0 9.01-3.504 17.2-9.224 23.284L10.468 9.459z",
    fill: "#798FD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#potential_inline_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.133,
    y: 18.133,
    width: 31.733,
    height: 31.733,
    rx: 4,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.646 24.84c-4.96.188-8.813 4.421-8.813 9.385V41.5a1.667 1.667 0 001.667 1.667h2.083a1.25 1.25 0 001.25-1.25v-5a1.25 1.25 0 00-1.25-1.25H26.5v-1.483c0-4.059 3.152-7.525 7.208-7.679A7.508 7.508 0 0141.5 34v1.667h-2.083a1.25 1.25 0 00-1.25 1.25v5a1.25 1.25 0 001.25 1.25H41.5a1.667 1.667 0 001.667-1.667V34a9.178 9.178 0 00-9.52-9.16z",
    fill: "#6B7696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.583 35.667h-1.25v7.5h1.25a1.25 1.25 0 001.25-1.25v-5a1.25 1.25 0 00-1.25-1.25zM39.417 35.667h1.25v7.5h-1.25a1.25 1.25 0 01-1.25-1.25v-5a1.25 1.25 0 011.25-1.25z",
    fill: "#363C4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.333 35.667H26.5v7.5h.833v-7.5zM41.5 35.667h-.833v7.5h.833v-7.5z",
    fill: "#E3E5EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "potential_inline_svg__filter0_d",
    x: 10.133,
    y: 18.133,
    width: 47.733,
    height: 47.733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.172965 0 0 0 0 0.162254 0 0 0 0 0.366665 0 0 0 0.49867 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default SvgPotentialinline;